/**
 * @file: 提货待办组件
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/09/26      1.0     First version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent,Fragment} from "react";
import {Alert, Drawer,Spin,message,Popconfirm} from 'antd';
import Lang from "@/components/Lang/Lang";
import BatchPickUpPoDrawer from "@/components/batchPickUpPoDrawer/batchPickUpPoDrawer";
import { toFixedWithCommas} from "@utils/number-util";
import {isEmpty,symbolMoneyUtil,toFixed2} from '@utils/utils';
import LogisticsInformation from '@components/Logistics/LogisticsInformation';
import ModalOrderDetail from "@components/ModalOrderDetails/ModalOrderDetail";
import AutoFetchList from '@components/AutoFetchList/AutoFetchList';
import DopIndexAction from "../../dopIndex.action"
import "./takeDeliveryGoodsDrawer.less";
export default class TakeDeliveryGoodsDrawer extends PureComponent {
    static defaultProps = {
        type: "", // 显示 1:定金 * 2:尾款 * 3:提货
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }
    /**
     * 抽屜
     * */
    showDrawer = (flag=true) => {
        if(this.props.showDrawer){ // 打开抽屉后回调
            this.props.showDrawer(flag)
        }
        this.setState({
            visible: flag,
        });

    }
    renderOne(poModel,inx){
        const sCountryUrl =poModel.abbreviate?require('../../../../assets/img/country/'+poModel.abbreviate + '.png'):"";
        return (<div className={"showList black89 font_14 lineH_21"} key={poModel.id+"_a"+inx}>
            <div className={"flex-item-between mb_12"}>
                <div className={""}>
                    <div className={"flex-item-ver-center lineH_27"}>
                        {poModel.abbreviate?<img className="mr_4" src={sCountryUrl.default} width={24} />:null}
                        <span className={"fw_700 font_18"}>{poModel.buyerCode||"-"}</span>
                    </div>
                    <div className={"black45 lineH_21"}>{poModel.buyerName}</div>
                </div>
                <span className={"flex-item-ver-center"}>
                                            <i className={"ri-phone-fill black45 mr_4 font_20"} />
                                            <span className={"fw_700 font_16 lineH_24"}> +{poModel.telCode||"-"} {poModel.mobile||"-"}</span>
                                        </span>
            </div>
            {poModel.poVOList&&poModel.poVOList.length>0&&poModel.poVOList.map((poItem,index)=><div className={"subBox"} key={poItem.id+"_s"+index}>
                <div className={"flex-item-between"}>
                    <div>
                        <div className={"font_16 lineH_24"}>
                            {poItem.poCode}
                            {poItem.inStorageDays>0?<span className={"ml_4 labelDays"}>{poItem.freeEndDays<0?Lang({
                                id:"RuKuNTian3",default:`入库 ${poItem.inStorageDays}天，超出免费停仓 ${Math.abs(poItem.freeEndDays)}天`,
                                params:[poItem.inStorageDays, Math.abs(poItem.freeEndDays)]}):Lang({
                                id:"RuKuNTian2",default:`入库 ${poItem.inStorageDays}天，免费停仓时间剩余 ${poItem.freeEndDays}天`,
                                params:[poItem.inStorageDays, poItem.freeEndDays]})}</span>:null}
                        </div>
                        <div className={"black66 flex-item-ver-center mt_4"}>
                            {/* 总计 */}
                            {/*箱*/}
                            <span className={"ri-archive-2-fill black33 font_16 mr_4"}></span><span>{Lang({id:"NXiang",default:"{0}箱",params:[isEmpty(poItem.totalQuantity)?"-":poItem.totalQuantity]})}</span>
                            {/*款*/}
                            {/*<span className="tit margin-left-5">{model.totalCount||'-'}{__getServerLanguage('Kuan')}</span>，*/}
                            {/* 体积 重量*/}
                            <span className={"ri-box-3-fill black33 font_16 ml_20 mr_4"}></span>{isEmpty(poItem.totalVolume)?"-":toFixed2(poItem.totalVolume,3)} m³
                            <span className={"ri-scales-2-fill black33 font_16 ml_20 mr_4"}></span>{isEmpty(poItem.totalGrossWeight)?"-":toFixed2(poItem.totalGrossWeight,3)} kg
                            {/* 中转城市名称 */}
                            <span className={"ri-hotel-fill black33 font_16 ml_20 mr_4"}></span>{poItem.transitCityName}{Lang({id:"CangKu",default:"仓库",})}
                        </div>
                    </div>
                    <div>
                        <LogisticsInformation showSimpleIcon={true} poId={poItem.poId}>
                            <span className={"btnWhite"}>{Lang({id:"WuLiu",default:"物流",})}</span>
                        </LogisticsInformation>
                        <ModalOrderDetail id={poItem.poId}>
                            <span className={"btnWhite ml_8"}>{Lang({id:"XiangQing",default:"详情",})}</span>
                        </ModalOrderDetail>
                    </div>
                </div>
                <div className={"lineGrey"}></div>
                <div className={"flex-item-between"}>
                    <span>{Lang({id:"ZongJinE",default:"总金额",})} {symbolMoneyUtil(poItem.totalPrice,poItem.currencySymbol)} </span>
                    <div className={"flex-item-ver-center"}>
                        {poItem.noCertificateSplit!=1?<BatchPickUpPoDrawer buyerId={poModel.buyerId}
                                                                           selectPoIds={[poItem.poId]}
                                                                           reLoad={()=>this.refreshData()}
                                                                           className={"btnBlueContact"} >
                            {Lang({id:"YuYueTiHuo",default:"预约提货",})}</BatchPickUpPoDrawer>:null}
                        <Popconfirm placement="topRight"
                            title={Lang({id: "QueRenYiLianXiGuo",default: "确认已联系过？"})}
                            onConfirm={()=>this.contacted(poItem)}
                            okText={Lang({id:'queren',default:'确认'})}
                            cancelText={Lang({id:'QuXiao',default:'取消'})}>
                            <span className={"ml_8 btnBlueContact"}>{Lang({id:"YiLianXiGuo2",default:"已联系过",})}</span>
                        </Popconfirm>
                    </div>
                </div>
            </div>)}
        </div>)
    }
    /*
    * 催收任务/提货提醒 已联系
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8318
    * */
    contacted(poItem={}){
        this.loading(true);
        DopIndexAction.postHttpAction("/service/mg/home/task/contacted",{
            taskIds:[poItem.taskId]
        }).then(res=>this.getTodoRes(res.data)).catch(err=>this.getTodoRes(err));
    }
    getTodoRes(res){
        this.loading(false);
        const {success,valid,model={},} = res;
        if (success && valid) {
            message.success(Lang({id: 'CaoZuoChengGong', default: '操作成功'}));
            this.refreshData()
        }else if(res.message){
            message.warning(res.message);
        }else {
            message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        }
    }
    refreshData(){
        this.onRefAutoFetchListChrld.handleFetch(1,false);
        if(this.props.refreshPage){
            this.props.refreshPage();
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    // 列表
    onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChrld = ref;
    componentWillMount() {
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
        if(this.showTimer)clearTimeout(this.showTimer)
    };
    render() {
        const {className,children,btnName,canOpen=false,type="" } = this.props;
        const {loading = false, visible=false,} = this.state;
        return (<Fragment>
            <div className={`${canOpen?"cursor-p":""}${className?" "+className:""}`} onClick={()=>this.showDrawer(canOpen?true:false)}>{children}</div>
            <Drawer title={<div className={"flex-item-ver-center lineH_27"}>
                                <span className={"font_18 fw_500"}>{btnName||Lang({id:"DingJinCuiShou",default:"定金催收"})}</span>
                        </div>}
                    width={1100}
                    rootClassName={"takeDeliveryGoodsDrawer"}
                    // maskClosable={false}
                    destroyOnClose={true}
                    onClose={()=>this.showDrawer(false)}
                    open={visible}>
                        <Spin spinning={loading}>
                            <div className={"mb_12 alertMsg"}>
                                {/* 提货提醒 */}
                                <Alert className={"mb_12"} description={<div dangerouslySetInnerHTML={{__html:Lang({id:"DaiBanTiShiTiHuoTiXing",
                                    default:'<p>以下订单已完成了全部付款。请通知这些客户及时预约提货，并有必要向客户强调，<b>订单在仓库的免费停留时间只有30天！逾期将收费。</b></p><p>系统提醒规则：</p><p>第1次，入库后第2天</p><p>第2次，入库后第15天</p><p>第3次，入库后第25天</p>'})}}></div>} type="info" showIcon
                                       icon={<i className="ri-information-fill" style={{fontSize: "18px", marginTop: "10px", marginRight: "4px"}} />} />
                            </div>
                        <AutoFetchList onRef={this.onRefAutoFetchList}
                                       showTotal={false}
                                       precondition={{type:type}}
                                       fetchApi={'/service/mg/home/delivery/list'} // http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8314
                                       renderList={(item,inx)=>this.renderOne(item,inx)} />
                        </Spin>
            </Drawer>
        </Fragment>);
    }
}